import React from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import { Container, Wrapper, Grid, Thumbnail, Subheading } from './styles'
import Heading from '../Heading'
import Button from '../Button'
import { formatTitle } from '../../utils/helpers'

const Blog = ({ limit = 100 }) => {
  const data = useStaticQuery(
    graphql`
      query {
        allShopifyArticle(sort: { fields: publishedAt, order: DESC }) {
          edges {
            node {
              contentHtml
              excerpt
              handle
              id
              image {
                src
              }
              title
            }
          }
        }
      }
    `
  )

  const { edges } = data.allShopifyArticle
  const posts = edges.slice(0, limit)

  return (
    <Wrapper>
      <Container>
        <Link to={`/learn/`}>
          <Heading>
            <span>Learn</span> More
          </Heading>
          <Subheading>
            Articles to help you get familiar with CBD, Nootropics and
            flowstate!
          </Subheading>
        </Link>
      </Container>
      <Grid>
        {posts &&
          posts.map(({ node: { id, handle, title, image, excerpt } }) => {
            return (
              <div key={id}>
                <Link to={`/learn/${handle}`}>
                  <Thumbnail style={{ backgroundImage: `url(${image.src})` }} />

                  <div style={{ marginTop: 20, marginBottom: 10 }}>
                    <Heading
                      dangerouslySetInnerHTML={{ __html: formatTitle(title) }}
                      fontSize="28px"
                      mobileFontSize="22px"
                    />
                  </div>

                  <p>{excerpt}</p>

                  <Button background="white" color="#215041">
                    Read more &rarr;
                  </Button>
                </Link>
              </div>
            )
          })}
      </Grid>
    </Wrapper>
  )
}

export default Blog
